import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ErrorColumn extends Component {
    state = {
        showFull: false,
    }

    _handleToggleFull = () => {
        this.setState({
            showFull: !this.state.showFull
        })
    }

    render() {
        const {showFull} = this.state
        const {error} = this.props

        return <td className="Message">
            {showFull ? error : error.length > 50 ? <span>{error.substr(0,50)} <span onClick={this._handleToggleFull} className="text-primary font-weight-bold cursor-pointer">...</span> </span> : error}
        </td>
    }
}

ErrorColumn.propTypes = {
    error: PropTypes.string
}

export default ErrorColumn